import React, { useState, useEffect } from "react";
import "./EditProject.css";
import { projectEdit } from "../../../api/project/projectApi"; // ✅ projectEdit 함수 import

const EditProject = ({ open, onClose, project, refreshList }) => {
  const [name, setName] = useState("");
  const [memo, setMemo] = useState("");

  // ✅ 수정 대상(project) 정보 불러오기
  useEffect(() => {
    if (project) {
      setName(project.projectName || "");
      setMemo(project.projectMemo || "");
    }
  }, [project]);

  // ✅ 수정 API 호출
  // ✅ 수정 API 호출
const handleSave = async () => {
  if (!name.trim()) {
    alert("프로젝트 이름을 입력해주세요.");
    return;
  }

  try {
    // ✅ API 호출
    const res = await projectEdit(
      project.projectId,
      name,  // projectName
      memo   // projectDescription (또는 projectMemo)
    );

    if (res.status === 200) {
      alert("프로젝트가 성공적으로 수정되었습니다.");

      // ✅ 목록 갱신
      if (refreshList) refreshList();

      // ✅ 팝업 닫기
      onClose();
    } else {
      alert("프로젝트 수정에 실패했습니다. 다시 시도해주세요.");
    }
  } catch (error) {
    console.error("❌ 프로젝트 수정 오류:", error);
    alert("프로젝트 수정 중 오류가 발생했습니다.");
  }
};

  if (!open) return null;

  return (
    <div className="EditProject_Container">
      <div className="EditProject_TitleBox">프로젝트 수정</div>

      <div className="EditProject_NameContainer">
        <div className="EditProject_NameBox">프로젝트 이름</div>
        <input
          type="text"
          className="EditProject_NameTextFelid"
          placeholder="프로젝트 이름을 입력하세요"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className="EditProject__MemoContainer">
        <div className="EditProject_NameBox">프로젝트 설명</div>
        <input
          type="text"
          className="EditProject_MemoTextFelid"
          placeholder="프로젝트 설명을 입력하세요"
          value={memo}
          onChange={(e) => setMemo(e.target.value)}
        />
      </div>

      <div className="EditProject_BtnContainer">
        <div className="EditProject_Btn" onClick={handleSave}>
          저장
        </div>
        <div className="EditProject_Btn" onClick={onClose}>
          취소
        </div>
      </div>
    </div>
  );
};

export default EditProject;
